function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M263.542 508.874l160-160c4.167-4.167 4.167-10.917 0-15.083-4.167-4.167-10.917-4.167-15.083 0L266.667 475.583V10.666C266.667 4.77 261.896 0 256 0s-10.667 4.771-10.667 10.667v464.917L103.542 333.791c-4.167-4.167-10.917-4.167-15.083 0a10.634 10.634 0 00-3.125 7.542c0 2.73 1.042 5.458 3.125 7.542l160 160c4.166 4.166 10.916 4.166 15.083 0z",
  "data-original": "#000000",
  xmlns: "http://www.w3.org/2000/svg"
});

function SvgArrowWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    className: " w-full h-full fill-current"
  }, props), _ref);
}

export default SvgArrowWide;